import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["system_efficiency", "System efficiency", "Derating for temperature, wiring, soiling (0.75–0.85).", 0.01],
  ["inverter_margin", "Inverter margin", "Multiplier on measured peak kW.", 0.05],
  ["battery_dod", "Battery depth of discharge", "Usable fraction of nominal kWh.", 0.05],
  ["backup_fraction", "Night backup fraction", "Share of night-time kWh to store (1 = full night).", 0.1],
];

export default function SizingParams() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/settings", s); setS(data); toast.success("Engine parameters saved"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (!s) return <p className="kl-label">Loading…</p>;

  return (
    <form onSubmit={save} className="animate-rise max-w-3xl" data-testid="sizing-params-form">
      <div className="pb-6 border-b border-kl-black"><p className="kl-label">Engine</p><h2 className="font-display font-light text-3xl mt-1">Global parameters</h2><p className="text-sm text-kl-mutedLight mt-1">Shared by every country. Sun hours, tariff, currency and CO₂ factor are set per country under “Countries & currencies”.</p></div>
      <div className="divide-y divide-kl-lineLight">
        {FIELDS.map(([k, l, help, step]) => (
          <div key={k} className="grid grid-cols-[1fr_180px] gap-6 items-center py-4">
            <div><div className="font-display">{l}</div><div className="text-xs text-kl-mutedLight">{help}</div></div>
            <input data-testid={`param-${k}`} type="number" step={step} className="kl-input-box font-mono text-right" value={s[k]} onChange={(e) => setS({ ...s, [k]: parseFloat(e.target.value) })} />
          </div>
        ))}
        <div className="grid grid-cols-[1fr_180px] gap-6 items-center py-4"><div><div className="font-display">Company name</div><div className="text-xs text-kl-mutedLight">Signature on proposals.</div></div><input data-testid="param-company-name" className="kl-input-box" value={s.company_name} onChange={(e) => setS({ ...s, company_name: e.target.value })} /></div>
        <div className="grid grid-cols-[1fr_180px] gap-6 items-center py-4"><div><div className="font-display">Company email</div><div className="text-xs text-kl-mutedLight">Reply-to on proposals.</div></div><input data-testid="param-company-email" type="email" className="kl-input-box" value={s.company_email} onChange={(e) => setS({ ...s, company_email: e.target.value })} /></div>
      </div>
      <div className="flex justify-end pt-6"><button disabled={busy} className="kl-btn-primary" data-testid="params-save-button">{busy ? "Saving…" : "Save parameters"}</button></div>
    </form>
  );
}
